import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

export interface ChecklistTable {
  table: string
  label: string
  required: boolean
  has_data: boolean
  row_count: number
  file_hint: string
}

export interface ChecklistSection {
  section: string
  label: string
  icon: string
  completeness_pct: number
  tables: ChecklistTable[]
  missing_hints: string[]
}

export function useChecklist() {
  return useQuery<ChecklistSection[]>({
    queryKey: ['checklist'],
    queryFn: () => api.get<ChecklistSection[]>('/api/v1/checklist'),
    staleTime: 30_000,
  })
}
